import React from 'react';
import PropTypes from 'prop-types';
import { Col, FormGroup, ControlLabel, HelpBlock } from 'react-bootstrap';
import { DateTimePicker } from 'react-widgets';
import utils from '../../services/utils';
import 'react-widgets/dist/css/react-widgets.css';
import ReactWidgetsConfigure from 'react-widgets/lib/configure';
import ReactWidgetsCustomLocalizer from './ReactWidgetsLocalizer';

ReactWidgetsConfigure.setDateLocalizer(ReactWidgetsCustomLocalizer);

const setDefaultTime = (date, defaultCurrentDate) => {
	date.setHours(defaultCurrentDate.getHours());
	date.setMinutes(defaultCurrentDate.getMinutes());
	date.setSeconds(defaultCurrentDate.getSeconds());
	date.setMilliseconds(defaultCurrentDate.getMilliseconds());
};

const DateTimeInput = ({ showTime, horizontal, required, input: { onChange, value }, label, labelCol = 2, valueCol = 10, type, help, meta: { touched, error, warning }, dateFormat, defaultCurrentDate, ...props }) => {
	const validationState = touched && (error && "error") || (warning && "warning") || null;

	let dateValue = null;
	if (value) {
		dateValue = utils.parseDateTime(value, dateFormat);
		if (!showTime && defaultCurrentDate) {
			// keep initially selected time
			setDefaultTime(dateValue, defaultCurrentDate);
		}
	}

	const formControl = <DateTimePicker
		onChange={date => {
			if (date && !showTime && defaultCurrentDate) {
				setDefaultTime(date, defaultCurrentDate);
			}
			onChange(date);
		}}
		value={dateValue}
		time={showTime}
		defaultCurrentDate={defaultCurrentDate}
		{...props}
	/>;
	const errorBlock = touched && (error || warning) && <HelpBlock>{error || warning}</HelpBlock>;
	const helpBlock = help && <HelpBlock>{help}</HelpBlock>;
	const labelHint = required && <em className='required_s'>*</em>;

	if (horizontal) {
		return (
			<FormGroup validationState={validationState}>
				<Col componentClass={ControlLabel} sm={labelCol}>
					{label}{labelHint}
				</Col>
				<Col sm={valueCol}>
					{formControl}
					{errorBlock}
					{helpBlock}
				</Col>
			</FormGroup>);
	}

	return (
		<FormGroup validationState={validationState}>
			<ControlLabel>{label}{labelHint}</ControlLabel>
			{formControl}
			{errorBlock}
			{helpBlock}
		</FormGroup>
	);
};

DateTimeInput.propTypes = {
	showTime: PropTypes.bool,
	horizontal: PropTypes.bool,
	input: PropTypes.object,
	label: PropTypes.string,
	help: PropTypes.string,
	meta: PropTypes.object,
	placeholder: PropTypes.string,
	disabled: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
	value: PropTypes.string
};

export default DateTimeInput;